import PageLoadedQueue from "./PageLoadedQueue";

/**
 * Makes the header fixed when scrolling
 */
export function headerFixable(): void {
    const header = document.querySelector('.header-fixed') as HTMLElement;

    /**
     * check if the meta menu is visible and at the top of the page
     */
    const makeHeaderFixed = () => {
        if (window.scrollY > 0) {
            header.classList.add('is-fixed');
        } else {
            header.classList.remove('is-fixed');
        }
    };

    window.addEventListener('scroll', makeHeaderFixed);
    window.addEventListener('resize', makeHeaderFixed);
}

PageLoadedQueue.addFunction(headerFixable);
